// J-209 (the owner's inbox file 06, PR D item 8): the app's own page for a route that failed to load or
// render (an address with a value the screen cannot read, a loader that threw), in place of the
// router's default error page. It reports the error through telemetry and shows no error text or stack
// to the user (T12 rule 9).
import * as React from "react";
import { type ErrorComponentProps, Link, useRouter } from "@tanstack/react-router";

import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";
import { Button } from "@vbltc/ui/button";

import { reportError } from "../telemetry";

export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  React.useEffect(() => reportError(error, "router.errorComponent"), [error]);
  return (
    <div className="mx-auto grid max-w-2xl gap-3 p-6" data-testid="route-error">
      <AlertBanner variant="warning" live title="This page could not be shown">
        The address holds a value this screen cannot read, or the page failed to load.
      </AlertBanner>
      <div className="flex gap-3">
        {/* J-215: Try again runs the route's reads again; resetting the boundary alone showed the
            same error. */}
        <Button
          variant="outline"
          onClick={() => {
            reset();
            void router.invalidate();
          }}
        >
          Try again
        </Button>
        <Link to="/" className="self-center text-sm underline">
          Go to the start page
        </Link>
      </div>
    </div>
  );
}
